// DO NOT EDIT: autogenerated by brokkr
import { CreateIconOptions } from "./types";
export const falU: CreateIconOptions = {
  "displayName": "FALU",
  "viewBox": "0, 0, 384, 512",
  "d": "M16 32c8.8 0 16 7.2 16 16l0 240c0 88.4 71.6 160 160 160s160-71.6 160-160l0-240c0-8.8 7.2-16 16-16s16 7.2 16 16l0 240c0 106-86 192-192 192S0 394 0 288L0 48c0-8.8 7.2-16 16-16z"
};
